var cashbackAttributeDone = false;
var cashbackStorageKey = "promo_cashback";

function markCashbackPromoFromUrl() {
  var promo = new URLSearchParams(window.location.search).get("promo");
  if (promo !== "cashback") return;

  try {
    sessionStorage.setItem(cashbackStorageKey, "true");
  } catch (e) {}
}

function hasCashbackPromo() {
  try {
    return sessionStorage.getItem(cashbackStorageKey) === "true";
  } catch (e) {
    return false;
  }
}

function markCashbackPromoOnPage() {
  if (hasCashbackPromo())
    document.documentElement.classList.add("cm-cashback-promo");
}

function setCashbackAttribute() {
  if (cashbackAttributeDone) return;
  if (!hasCashbackPromo()) return;
  cashbackAttributeDone = true;

  cashbackOriginalFetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ attributes: { cashback: "needed" } }),
  });
}

markCashbackPromoFromUrl();
markCashbackPromoOnPage();

// fetch("/cart/add.js") calls
var cashbackOriginalFetch = window.fetch;

window.fetch = function (url, options) {
  var request = cashbackOriginalFetch.apply(this, arguments);

  if (typeof url === "string" && url.indexOf("/cart/add") !== -1) {
    request.then(function (res) {
      if (res.ok) setCashbackAttribute();
    });
  }

  return request;
};

// jQuery $.ajax("/cart/add.js") calls
if (window.jQuery) {
  jQuery(document).ajaxSuccess(function (event, xhr, settings) {
    if (settings.url && settings.url.indexOf("/cart/add") !== -1)
      setCashbackAttribute();
  });
}
